import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { setTwitter as setTwitterAction } from '../../actions/SiteActions';
import { loadTwitter } from '../../lib/request';

// import * as AppPropTypes from '../../lib/PropTypes';
import NewsletterForm from '../forms/Newsletter';
import Twitter from './Twitter';
import Socials from './Socials';
import Partners from './Partners';
import Label from './Label';
import Button from '../buttons/Button';

import styles from '../../../styles/partials/footer.scss';

const messages = defineMessages({
    newsletterTitle: {
        id: 'content.newsletter_title',
        defaultMessage: 'Subscribe',
    },
    newsletterDescription: {
        id: 'content.newsletter_description',
        defaultMessage: 'Sign up with your email address to receive news and updates.',
    },
    newsletterThankYou: {
        id: 'content.newsletter_thankyou',
        defaultMessage: 'Thank you for your subscription!',
    },
    button: {
        id: 'content.contact_button',
        defaultMessage: 'Contact Us',
    },
});

const propTypes = {
    withTwitter: PropTypes.bool,
    twitterItems: PropTypes.array, // eslint-disable-line
    setTwitter: PropTypes.func.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    withTwitter: true,
    twitterItems: [],
    className: null,
};

const Footer = ({ setTwitter, withTwitter, twitterItems, className }) => {
    const [newsletterComplete, setNewsletterComplete] = useState(false);
    const onNewsletterComplete = useCallback(() => setNewsletterComplete(true), [
        setNewsletterComplete,
    ]);

    useEffect(() => {
        loadTwitter().then(twitter => {
            setTwitter(twitter);
        });
    }, []);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            {withTwitter ? (
                <div className={styles.twitterContainer}>
                    {twitterItems.map(item => (
                        <Twitter item={item} className={styles.twitter} />
                    ))}
                </div>
            ) : null}
            <div
                className={classNames([
                    styles.inner,
                    {
                        [styles.noTwitter]: withTwitter === false,
                    },
                ])}
            >
                <Socials className={styles.socials} />
                <div className={styles.newsletter}>
                    <h4 className={styles.title}>
                        <Label>{messages.newsletterTitle}</Label>
                    </h4>
                    <p className={styles.description}>
                        <Label>{messages.newsletterDescription}</Label>
                    </p>
                    {newsletterComplete ? (
                        <div className={styles.thankyou}>
                            <Label>{messages.newsletterThankYou}</Label>
                        </div>
                    ) : (
                        <NewsletterForm className={styles.form} onComplete={onNewsletterComplete} />
                    )}
                </div>
                <Button
                    type="button"
                    label={messages.button}
                    className={styles.contact}
                    external
                    href="mailto:findingsally@catbirdproductions.ca"
                />
                <Partners className={styles.partners} />
            </div>
        </div>
    );
};

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;

const WithStateContainer = connect(
    ({ site: { twitter } }) => ({
        twitterItems: twitter,
    }),
    dispatch => ({
        setTwitter: twitter => dispatch(setTwitterAction(twitter)),
    }),
)(Footer);

export default WithStateContainer;
